import { Card, Grid, Stack, Typography, Box } from "@mui/material";
import { m } from "framer-motion";
import { LoadingButton } from "@mui/lab";
import { styled } from "@mui/material/styles";
import { useLocales } from "../../../locales";
import useResponsive from "../../../hooks/minimal/useResponsive";
import { SupportedPaymentMethod } from "./SupportedPaymentMethod";
import { useMarketplaceContext } from "../../../context-state/MarketplaceContext";
import { useEffect } from "react";
import facebookPixel from "../../../utils/facebookPixel";
import googleAnalytics from "../../../utils/googleAnalytics";

const InputContainerStyled = styled('div')(({ theme, isDesktop }) => {
    return {
        width: isDesktop ? "50%" : "100%",
        lineHeight: "1.4375em",
        fontFamily: theme.typography.fontFamily,
        fontSize: theme.typography.body1.fontSize,
        fontWeight: 400,
        color: theme.palette.text.primary,
        boxSizing: "border-box",
        position: "relative",
        height: "50px",
        border: "1px solid rgba(0, 0, 0, 0.23)",
        display: "inline-flex",
        alignItems: "center",
        boxAlign: "center",
        flexAlign: "center",
        padding: "0 10px",
        borderRadius: "8px"
    }
})

export const PayForm = ({ totalToPayAfterCoupon, onSubmit, isLoading, paymentFormError, forceDisableBtn, inputStyle = {} }) => {

    const { translate } = useLocales()
    const { marketplace } = useMarketplaceContext()
    const { creditCardsAllowed } = marketplace || {}
    const isDesktop = useResponsive('up', 'md');

    useEffect(() => {
        // fire facebook pixel InitiateCheckout if facebook pixel exists for this event
        facebookPixel.track('InitiateCheckout', {
            content_type: 'ticket',
            value: totalToPayAfterCoupon,
            currency: 'ILS'
        })
        googleAnalytics.initCheckout({ value: totalToPayAfterCoupon, currency: 'ILS', content_type: 'ticket' })
    }, [totalToPayAfterCoupon])

    return (
        <Grid initial={{ opacity: 0, x: -80 }} animate={{ opacity: 1, x: 0 }} transition={{ duration: 0.4 }} component={m.div} item xs={12} md={12}>
            <Card sx={{ p: 2, mb: 2 }}>
                <Stack sx={{ position: "relative" }} spacing={2} justifyContent="center" alignItems="center">
                    <Typography variant="subtitle1">{translate('event_page.total_to_pay')} - {translate('currency.format', { value: totalToPayAfterCoupon })}</Typography>
                    <Typography sx={{ minHeight: "35px", color: "error.main", textAlign: "center" }} variant="body1">
                        {paymentFormError || undefined}
                    </Typography>
                    <Box width={isDesktop ? '50%' : '100%'} sx={inputStyle} >
                        {creditCardsAllowed && <SupportedPaymentMethod creditCards={creditCardsAllowed} />}
                    </Box>
                    <InputContainerStyled sx={inputStyle} isDesktop={isDesktop} id="card-number-container" />
                    <InputContainerStyled sx={inputStyle} isDesktop={isDesktop} id="card-cvv-container" />
                    <InputContainerStyled sx={inputStyle} isDesktop={isDesktop} id="card-expiration-container" />
                    <InputContainerStyled sx={inputStyle} isDesktop={isDesktop} id="card-holder-first-name-container" />
                    <InputContainerStyled sx={inputStyle} isDesktop={isDesktop} id="card-holder-last-name-container" />
                    <LoadingButton size="large" loading={isLoading} disabled={forceDisableBtn} variant="contained" onClick={onSubmit} sx={{ width: !isDesktop ? '100%' : '50%' }}>
                        {translate('event_page.pay_now')}
                    </LoadingButton>
                </Stack>
            </Card>
        </Grid>
    )
}

export const PayFormClean = ({ totalToPayAfterCoupon, onSubmit, isLoading, paymentFormError, forceDisableBtn, inputStyle = {} }) => {

    const { translate } = useLocales()
    const { marketplace } = useMarketplaceContext()
    const { creditCardsAllowed } = marketplace || {}
    const isDesktop = useResponsive('up', 'md');

    useEffect(() => {
        // fire facebook pixel InitiateCheckout if facebook pixel exists for this event
        facebookPixel.track('InitiateCheckout', {
            content_type: 'ticket',
            value: totalToPayAfterCoupon,
            currency: 'ILS'
        })
        googleAnalytics.initCheckout({ value: totalToPayAfterCoupon, currency: 'ILS', content_type: 'ticket' })
    }, [totalToPayAfterCoupon])

    return (

        <Stack sx={{ position: "relative" }} spacing={2} justifyContent="center" alignItems="center">
            <Typography variant="subtitle1">{translate('event_page.total_to_pay')} - {translate('currency.format', { value: totalToPayAfterCoupon })}</Typography>
            <Box width={isDesktop ? '50%' : '100%'} sx={inputStyle} >
                {creditCardsAllowed && <SupportedPaymentMethod creditCards={creditCardsAllowed} />}
            </Box>
            <InputContainerStyled sx={inputStyle} isDesktop={isDesktop} id="card-number-container" />
            <InputContainerStyled sx={inputStyle} isDesktop={isDesktop} id="card-cvv-container" />
            <InputContainerStyled sx={inputStyle} isDesktop={isDesktop} id="card-expiration-container" />
            <InputContainerStyled sx={inputStyle} isDesktop={isDesktop} id="card-holder-first-name-container" />
            <InputContainerStyled sx={inputStyle} isDesktop={isDesktop} id="card-holder-last-name-container" />
            <LoadingButton size="large" loading={isLoading} disabled={forceDisableBtn} variant="contained" onClick={onSubmit} sx={{ width: !isDesktop ? '100%' : '50%' }}>
                {translate('event_page.pay_now')}
            </LoadingButton>
            <Typography sx={{ minHeight: "25px", color: "error.main", textAlign: "center" }} variant="body1">
                {paymentFormError || undefined}
            </Typography>
        </Stack>

    )
}
